import { put, takeEvery } from 'redux-saga/effects';
import * as types from '../actions/actionTypes';
import RequestService from '../services/SubscriptionRequestService';
import { loadSubscriptionRequestsSuccess, loadSubscriptionRequestsSizeSuccess } from '../actions/subscriptionRequestActions'
import { loadSubscriptionSuccess } from '../actions/subscriptionActions';
import { loadAssetSuccess } from '../actions/assetActions';

function* getSubscriptionRequests(data:any) {
  const subscriptionRequestService = RequestService.Instance;
  const requests = yield subscriptionRequestService.getRequestsList(data);
  yield put(loadSubscriptionRequestsSuccess(requests))
}
function* getSubscriptionRequestsSize() {
  const subscriptionRequestService = RequestService.Instance;
  const requests = yield subscriptionRequestService.getRequestsize();
  yield put(loadSubscriptionRequestsSizeSuccess(requests))
}

function* getSubscriptions(data: any) {
  const subscriptionRequestService = RequestService.Instance;
  const subscriptions = yield subscriptionRequestService.getAllSubscriptions(data);
  const assets = yield subscriptionRequestService.getAssetList();
  yield put(loadAssetSuccess(assets))
  yield put(loadSubscriptionSuccess(subscriptions));
}



function* subscriptionRequestSaga() {
  yield takeEvery(types.START_LOAD_SUBSCRIPTIONREQUEST, getSubscriptionRequests);
  yield takeEvery(types.START_LOAD_SUBSCRIPTION, getSubscriptions);
  yield takeEvery(types.START_LOAD_SUBSCRIPTIONREQUESTSIZE, getSubscriptionRequestsSize)
}

export default subscriptionRequestSaga


// WEBPACK FOOTER //
// ./src/modules/core/sagas/subscriptionRequestSaga.tsx